import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { PermissionCheck } from "features/../../../shared/components/auth";
import { getAuthClaims } from "@redriver/cinnamon";
import { claimExists } from "features/../../../shared/components/auth/utils";
import { getSheetDataState } from "features/Sheets";

const ImpersonatedUserPermissionCheck = ({
  target,
  action,
  any = false,
  renderFailure = null,
  children = null,
}) => {
  const { impersonatedUser } = useSelector(getSheetDataState);
  const impersonatedUserSelected =
    impersonatedUser?.userType != null && impersonatedUser.permissions != null;

  const hasPermission =
    impersonatedUser?.permissions &&
    (Array.isArray(impersonatedUser.permissions[target])
      ? impersonatedUser.permissions[target].includes(action)
      : impersonatedUser.permissions[target] === action);

  // Do not render if we are impersonating a user without the required permission
  if (impersonatedUserSelected && !hasPermission) {
    return null;
  }

  // If we are either not impersonating, or we are impersonating a user with the required permission, wrap in a standard PermissionCheck
  return (
    <PermissionCheck
      target={target}
      action={action}
      any={any}
      renderFailure={renderFailure}
    >
      {children}
    </PermissionCheck>
  );
};

ImpersonatedUserPermissionCheck.propTypes = {
  target: PropTypes.string.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  any: PropTypes.bool,
  renderFailure: PropTypes.func,
  children: PropTypes.node,
};

ImpersonatedUserPermissionCheck.defaultProps = {
  any: false,
  renderFailure: null,
  children: null,
};

export default ImpersonatedUserPermissionCheck;
